import { ProjectPart } from "./project-part";

export class AssessmentTarget extends ProjectPart {
  pcProjectObjectiveMeasureID: number;
  targetType: string ;
  targetData: {
    description: string,
    finding: string,
    analysisOfFinding: string,
    improvementsAchieved: string,
    achievementsAchieved: string
  };
  improvementsAchieved: string; //id
  improvementsAchievedType: string; //id
  achievementStatus: string;
  healthy: boolean;
  healthyFinding: boolean;
  referenceILOTargetGuid: string; //id
  sortOrder: string;
  name: string;

  statusClass: string;

  fieldsDisabled: boolean = false;
  descriptionDisabled: boolean = false;
  findingDisabled: boolean = false;
  analysisOfFindingDisabled: boolean = false;
  improvementsAchievedDisabled: boolean = false;
  achievementsAchievedDisabled: boolean = false;

  expandedActionPlan: boolean = false;

  constructor(
    prefix: string = "",
    id: number = 0,
    requestKey: string = "",
    expanded: boolean = true,
    pcProjectObjectiveMeasureID: number = 0,
    targetType: string = "",
    description: string = "",
    finding: string = "",
    analysisOfFinding: string = "",
    targetDataImprovementsAchieved: string = "",
    achievementsAchieved: string = "",
    improvementsAchieved: string = "",
    achievementStatus: string = "",
    referenceILOTargetGuid: string = null,
    healthy: boolean = false,
    healthyFinding: boolean = false,
    sortOrder: string = "",
    name: string = "",
    statusClass: string = "",
    fieldsDisabled: boolean = false,
    descriptionDisabled: boolean = false,
    findingDisabled: boolean = false,
    analysisOfFindingDisabled: boolean = false,
    improvementsAchievedDisabled: boolean = false,
    achievementsAchievedDisabled: boolean = false,
  ) {
    super("target", id, requestKey, expanded, prefix);
    this.pcProjectObjectiveMeasureID = pcProjectObjectiveMeasureID;
    this.targetType = targetType;
    this.targetData = {
      description: description,
      finding: finding,
      analysisOfFinding: analysisOfFinding,
      improvementsAchieved: targetDataImprovementsAchieved,
      achievementsAchieved: achievementsAchieved
    };
    this.improvementsAchieved = improvementsAchieved;
    this.achievementStatus = achievementStatus;
    this.healthy = healthy;
    this.healthyFinding = healthyFinding;
    this.referenceILOTargetGuid = referenceILOTargetGuid;
    this.sortOrder = sortOrder;
    this.name = name;
    this.statusClass = statusClass;
    this.fieldsDisabled = fieldsDisabled;
    this.descriptionDisabled = descriptionDisabled;
    this.findingDisabled = findingDisabled;
    this.analysisOfFindingDisabled = analysisOfFindingDisabled;
    this.improvementsAchievedDisabled = improvementsAchievedDisabled;
    this.achievementsAchievedDisabled = achievementsAchievedDisabled;
    this.expandedActionPlan = false;
  }
}
